import {apiHttpClient} from "@/http/httpClient";
import type {TransportVehicle, TransportVehicleListRequest} from "@/models/transport-vehicle/transport-vehicle";
import type {TransportVehiclePreviewModel} from "@/models/transport-vehicle/transport-vehicle-preview";
import type { TransportVehicleScheduleRequest } from '@/models/transport-vehicle/transport-vehicle-schedule';

const ENDPOINT_LIST_TRANSPORT_VEHICLES = 'TransportVehicle/List';
const ENDPOINT_CREATE_TRANSPORT_VEHICLE = 'TransportVehicle/create';
const ENDPOINT_UPDATE_TRANSPORT_VEHICLE = 'TransportVehicle/update';
const ENDPOINT_GET_TRANSPORT_VEHICLE_BY_ID = 'TransportVehicle/get';
const ENDPOINT_DELETE_TRANSPORT_VEHICLE = 'TransportVehicle/delete';
const ENDPOINT_GET_TRANSPORT_VEHICLE_PREVIEW = "TransportVehicle/GetPreview";
const ENDPOINT_TRANSPORT_VEHICLE_SCHEDULE = 'TransportVehicle/GetTransportVehicleSchedule';

export const listTransportVehicles = async (transportVehicleListRequest: TransportVehicleListRequest) => {
    return await apiHttpClient().post<TransportVehicle>(ENDPOINT_LIST_TRANSPORT_VEHICLES, transportVehicleListRequest)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const createTransportVehicle = async (transportVehicle: TransportVehicle) => {
    return await apiHttpClient().post<TransportVehicle>(ENDPOINT_CREATE_TRANSPORT_VEHICLE, transportVehicle)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateTransportVehicle = async (transportVehicle: TransportVehicle) => {
    return await apiHttpClient().put<TransportVehicle>(ENDPOINT_UPDATE_TRANSPORT_VEHICLE, transportVehicle)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getTransportVehicleById = async (id: number) => {
    return await apiHttpClient().get<TransportVehicle>(`${ENDPOINT_GET_TRANSPORT_VEHICLE_BY_ID}?Id=${id}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const deleteTransportVehicle = async (id: number) => {
    return await apiHttpClient().delete(`${ENDPOINT_DELETE_TRANSPORT_VEHICLE}?Id=${id}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getTransportVehiclePreview = async (id: number) => {
    return await apiHttpClient().get<TransportVehiclePreviewModel>(`${ENDPOINT_GET_TRANSPORT_VEHICLE_PREVIEW}?Id=${id}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getTransportVehicleSchedule = async (transportVehicleScheduleRequest: TransportVehicleScheduleRequest) => {
    return await apiHttpClient()
        .post(ENDPOINT_TRANSPORT_VEHICLE_SCHEDULE, transportVehicleScheduleRequest)
        .then((response) => response)
        .catch((error) => error);
};